import { ApiService } from './api-service';

export class StudyPlanService extends ApiService {
  getUserTopicPlan = (params, config) => this.get('/user/topic/plan', params, config);

  getUserPlanFilter = id => this.get(`/user/${id}/plan/filter`);
}

export default new StudyPlanService();
